import { ReactElement } from "react";
import HorizontalRule from "../../HorizontalRule/HorizontalRule";



export function FormFieldWrapper({ children, label, className, hideRule }: { children: ReactElement, label: string, className?: string, hideRule?: boolean }) {
    return (<>
        <div className={`flex w-full items-center p-2 ${className}`}>
            <span className="w-1/2 font-bold">{label}</span>
            <div className="w-1/2">
                {children}
            </div>
        </div>
        {!hideRule ? <HorizontalRule/> : null}
        
        </>)
}